import type { AdvisorMarketplaceAction } from '@src/components/sco/Advisors/utils/advisorMarketplaceActions'

/**
 * Directory card CTA layout (walk #14): one full-width primary, the rest side by side.
 * "View Profile" is dropped when the card has any other action — the whole card and the name
 * already open the profile — and kept when it is the only thing to do (own card, or a guest on an
 * advisor who takes no sessions).
 */
export const directoryCardActions = (
  actions: AdvisorMarketplaceAction[]
): { primary: AdvisorMarketplaceAction | null; secondary: AdvisorMarketplaceAction[] } => {
  const withoutProfile = actions.filter(action => action.key !== 'profile')
  const list = withoutProfile.length > 0 ? withoutProfile : actions
  if (list.length === 0) {
    return { primary: null, secondary: [] }
  }
  const primaryIndex = Math.max(
    list.findIndex(action => action.variant === 'cta'),
    0
  )
  return {
    primary: list[primaryIndex],
    secondary: list.filter((_, index) => index !== primaryIndex),
  }
}
